import i18n from '../../i18n';

export const APP_TUTORIAL_STORAGE_KEY = 'HG_APP_TUTORIAL_SEEN_V1';

const getPosSteps = () => [
    {
        id: 'welcome',
        section: i18n.t('tutorial_section_basics'),
        routeName: 'HomeScreen',
        homeTabName: 'Sale',
        title: i18n.t('tutorial_welcome_title'),
        body: i18n.t('tutorial_welcome_body'),
    },
    {
        id: 'navigation-tabs',
        section: i18n.t('tutorial_section_basics'),
        routeName: 'HomeScreen',
        homeTabName: 'Sale',
        title: i18n.t('tutorial_navigation_tabs_title'),
        body: i18n.t('tutorial_navigation_tabs_body'),
    },
    {
        id: 'sale-screen',
        section: i18n.t('tutorial_section_sales'),
        routeName: 'HomeScreen',
        homeTabName: 'Sale',
        title: i18n.t('tutorial_sale_screen_title'),
        body: i18n.t('tutorial_sale_screen_body'),
    },
    {
        id: 'cart-screen',
        section: i18n.t('tutorial_section_sales'),
        routeName: 'HomeScreen',
        homeTabName: 'Cart',
        title: i18n.t('tutorial_cart_screen_title'),
        body: i18n.t('tutorial_cart_screen_body'),
    },
    {
        id: 'payment-flow',
        section: i18n.t('tutorial_section_sales'),
        routeName: 'HomeScreen',
        homeTabName: 'Cart',
        title: i18n.t('tutorial_payment_flow_title'),
        body: i18n.t('tutorial_payment_flow_body'),
    },
    {
        id: 'orders-screen',
        section: i18n.t('tutorial_section_orders'),
        routeName: 'HomeScreen',
        homeTabName: 'HomeOrdersList',
        title: i18n.t('tutorial_orders_screen_title'),
        body: i18n.t('tutorial_orders_screen_body'),
    },
    {
        id: 'functions-overview',
        section: i18n.t('tutorial_section_functions'),
        routeName: 'HomeScreen',
        homeTabName: 'Functions',
        title: i18n.t('tutorial_functions_overview_title'),
        body: i18n.t('tutorial_functions_overview_body'),
    },
    {
        id: 'functions-featured',
        section: i18n.t('tutorial_section_functions'),
        routeName: 'HomeScreen',
        homeTabName: 'Functions',
        title: i18n.t('tutorial_functions_featured_title'),
        body: i18n.t('tutorial_functions_featured_body'),
    },
    {
        id: 'functions-modals',
        section: i18n.t('tutorial_section_functions'),
        routeName: 'HomeScreen',
        homeTabName: 'Functions',
        title: i18n.t('tutorial_functions_modals_title'),
        body: i18n.t('tutorial_functions_modals_body'),
    },
    {
        id: 'settings-screen',
        section: i18n.t('tutorial_section_settings'),
        routeName: 'SettingsScreen',
        title: i18n.t('tutorial_settings_screen_title'),
        body: i18n.t('tutorial_settings_screen_body'),
    },
    {
        id: 'operations-screens',
        section: i18n.t('tutorial_section_operations'),
        routeName: 'HomeScreen',
        homeTabName: 'Functions',
        title: i18n.t('tutorial_operations_screens_title'),
        body: i18n.t('tutorial_operations_screens_body'),
    },
    {
        id: 'customer-screens',
        section: i18n.t('tutorial_section_guest_order'),
        routeName: 'HomeScreen',
        homeTabName: 'Sale',
        title: i18n.t('tutorial_customer_screens_title'),
        body: i18n.t('tutorial_customer_screens_body'),
    },
];

const getManagementSteps = () => [
    {
        id: 'manager-home',
        section: i18n.t('tutorial_section_management'),
        routeName: 'ManagementHomeScreen',
        title: i18n.t('tutorial_manager_home_title'),
        body: i18n.t('tutorial_manager_home_body'),
    },
    {
        id: 'manager-dashboard',
        section: i18n.t('tutorial_section_management'),
        routeName: 'ManagementHomeScreen',
        title: i18n.t('tutorial_manager_dashboard_title'),
        body: i18n.t('tutorial_manager_dashboard_body'),
    },
    {
        id: 'manager-lists',
        section: i18n.t('tutorial_section_management'),
        routeName: 'ManagementHomeScreen',
        title: i18n.t('tutorial_manager_lists_title'),
        body: i18n.t('tutorial_manager_lists_body'),
    },
    {
        id: 'manager-settings',
        section: i18n.t('tutorial_section_management'),
        routeName: 'ManagementHomeScreen',
        title: i18n.t('tutorial_manager_settings_title'),
        body: i18n.t('tutorial_manager_settings_body'),
    },
];

const getServiceSteps = () => [
    {
        id: 'service-home',
        section: i18n.t('tutorial_section_service'),
        routeName: 'RepairmanHomeScreen',
        title: i18n.t('tutorial_service_home_title'),
        body: i18n.t('tutorial_service_home_body'),
    },
    {
        id: 'service-workorders',
        section: i18n.t('tutorial_section_service'),
        routeName: 'WorkSheetListScreen',
        title: i18n.t('tutorial_service_workorders_title'),
        body: i18n.t('tutorial_service_workorders_body'),
    },
    {
        id: 'service-calendar',
        section: i18n.t('tutorial_section_service'),
        routeName: 'RepairmanCalendarScreen',
        title: i18n.t('tutorial_service_calendar_title'),
        body: i18n.t('tutorial_service_calendar_body'),
    },
];

const getWarehouseSteps = () => [
    {
        id: 'warehouse-home',
        section: i18n.t('tutorial_section_logistics'),
        routeName: 'WarehousemanHomeScreen',
        title: i18n.t('tutorial_warehouse_home_title'),
        body: i18n.t('tutorial_warehouse_home_body'),
    },
    {
        id: 'warehouse-receiving',
        section: i18n.t('tutorial_section_logistics'),
        routeName: 'WarehouseReceivingListScreen',
        title: i18n.t('tutorial_warehouse_receiving_title'),
        body: i18n.t('tutorial_warehouse_receiving_body'),
    },
    {
        id: 'warehouse-picking',
        section: i18n.t('tutorial_section_logistics'),
        routeName: 'WarehousePickingListScreen',
        title: i18n.t('tutorial_warehouse_picking_title'),
        body: i18n.t('tutorial_warehouse_picking_body'),
    },
];

const getClosingSteps = () => [
    {
        id: 'finish',
        section: i18n.t('tutorial_section_finish'),
        routeName: 'HomeScreen',
        homeTabName: 'Sale',
        title: i18n.t('tutorial_finish_title'),
        body: i18n.t('tutorial_finish_body'),
    },
];

export const buildAppTutorialSteps = ({isManagerMode = false, isServiceMode = false, isStockMode = false} = {}) => {
    const closingSteps = getClosingSteps();

    if (isManagerMode) {
        return [...getManagementSteps(), ...closingSteps.map((step) => ({...step, routeName: 'ManagementHomeScreen', homeTabName: undefined}))];
    }

    if (isServiceMode) {
        return [...getServiceSteps(), ...closingSteps.map((step) => ({...step, routeName: 'RepairmanHomeScreen', homeTabName: undefined}))];
    }

    if (isStockMode) {
        return [...getWarehouseSteps(), ...closingSteps.map((step) => ({...step, routeName: 'WarehousemanHomeScreen', homeTabName: undefined}))];
    }

    return [...getPosSteps(), ...getManagementSteps(), ...getServiceSteps(), ...getWarehouseSteps(), ...closingSteps];
};
